/* BeautyEssence pop-ups: routine finder + Welcome 10 (all devices) and exit rescue (desktop).
   Markup: sections/be-popups.liquid. Styles: be-popup-offers.css (loaded only when a pop-up is about to show).
   Rules: one overlay per browser session; frequency caps in days; never while the cart drawer or a menu is open;
   never for subscribed customers or after a sign-up on this device; never auto-opens in the theme editor. */
(function () {
  var root = document.querySelector('[data-be-popups]');
  if (!root || window.__bePops) return;
  window.__bePops = true;

  var D = root.dataset;
  var S = {};
  try { S = JSON.parse((document.querySelector('[data-be-pop-strings]') || {}).textContent || '{}'); } catch (e) {}
  var K = { session: 'be_overlay_shown', signed: 'be_signed_up', rfLast: 'be_rf_last', rfPending: 'be_rf_pending', teaserOff: 'be_rf_teaser_off', exitLast: 'be_exit_last' };
  var DAY = 864e5;
  var GOAL_TAG = { glow: 'be-goal-glow', hydration: 'be-goal-hydration', spf: 'be-goal-spf', peptide_care: 'be-goal-peptide', gentle_renewal: 'be-goal-renewal' };

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function within(key, days) { var t = parseInt(lsGet(key), 10) || 0; return t && Date.now() - t < days * DAY; }
  function track(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {} }
  function mq(q) { return !!(window.matchMedia && window.matchMedia(q).matches); }
  function decode(str) { var t = document.createElement('textarea'); t.innerHTML = str || ''; return t.value; }
  function money(cents) {
    var fmt = decode(D.moneyFormat) || '£{{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/); var key = m ? m[1] : 'amount';
    var comma = key.indexOf('comma_separator') !== -1;
    var v = (Math.max(0, cents) / 100).toFixed(2).split('.');
    var whole = v[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + (comma ? '.' : ','));
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, whole + (v[1] === '00' ? '' : (comma ? ',' : '.') + v[1]));
  }
  function loadCss() {
    if (document.querySelector('link[data-be-pop-css]') || !D.css) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = D.css; l.setAttribute('data-be-pop-css', '');
    document.head.appendChild(l);
  }
  var desktop = mq('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var editor = D.designMode === '1';
  var signed = function () { return D.subscribed === '1' || !!lsGet(K.signed); };

  /* Only real "open" states count. Dawn keeps the cart drawer, search and notification markup (with aria-modal)
     in the DOM at all times, hidden with visibility, so a generic aria-modal check would block forever. */
  function shown(el) {
    if (!el || el.closest('dialog.be-pop') || el.closest('details:not([open])')) return false;
    if (typeof el.checkVisibility === 'function' && !el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true, contentVisibilityAuto: true })) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.right > 0 && r.bottom > 0 && r.left < window.innerWidth && r.top < window.innerHeight;
  }
  function otherOverlayOpen(lenient) {
    if (document.querySelector('dialog.be-pop[open]')) return true;
    if (document.querySelector('cart-drawer.active, .drawer.active, .cart-notification.active, header-drawer details[open], menu-drawer details[open], details-modal details[open], modal-dialog[open], quick-add-modal[open], product-modal[open], details.be-mega-menu[open]')) return true;
    var b = document.body.classList;
    if (b.contains('overflow-hidden') || b.contains('overflow-hidden-mobile') || b.contains('overflow-hidden-tablet') || b.contains('overflow-hidden-desktop')) return true;
    if (lenient) return false; /* after several waits, only the explicit open states above still count */
    var modals = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < modals.length; i++) if (shown(modals[i])) return true;
    return false;
  }

  function openDialog(dlg, focusSel) {
    loadCss();
    if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); } else { dlg.setAttribute('open', ''); }
    document.documentElement.classList.add('be-pop-open');
    var f = focusSel && dlg.querySelector(focusSel);
    if (f) window.setTimeout(function () { f.focus(); }, 30);
  }
  function closeDialog(dlg) { if (typeof dlg.close === 'function' && dlg.open) dlg.close(); else { dlg.removeAttribute('open'); dlg.dispatchEvent(new Event('close')); } }

  /* Shared behaviour: close buttons, backdrop click, copy code. */
  document.querySelectorAll('dialog.be-pop').forEach(function (dlg) {
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('be-pop-open'); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { closeDialog(dlg); return; }
      if (e.target.closest('[data-be-pop-close]')) { closeDialog(dlg); return; }
      var copy = e.target.closest('[data-be-rf-copy]');
      if (copy) {
        var done = function () { copy.textContent = copy.dataset.done || (window.beI18n && window.beI18n.copied) || 'Copied'; };
        try { navigator.clipboard.writeText('WELCOME10').then(done, done); } catch (err) { done(); }
        track('be_popup_code_copied');
      }
    });
  });

  /* ---------------------------------------------------------------- Routine finder */
  var rf = document.querySelector('[data-be-routine]');
  var teaser = document.querySelector('[data-be-rf-teaser]');
  var rfDone = false;

  function rfStep(n) {
    rf.querySelectorAll('[data-be-rf-step]').forEach(function (s) { s.hidden = s.getAttribute('data-be-rf-step') !== String(n); });
    var t = rf.querySelector('[data-be-rf-step="' + n + '"] .be-pop__title');
    if (t) rf.setAttribute('aria-labelledby', t.id);
    rf.setAttribute('data-step', n);
  }
  function rfGoal() { var c = rf.querySelector('[data-be-rf-goal]:checked'); return c ? c.value : ''; }
  function rfSetTags(goal) {
    var input = rf.querySelector('[data-be-rf-tags]');
    var base = 'newsletter,source_popup_routine_finder,welcome_offer_received';
    input.value = goal ? base + ',interest_' + goal + ',' + GOAL_TAG[goal] : base;
  }
  function rfShowDone(goal) {
    rfDone = true;
    var list = rf.querySelector('[data-be-rf-products]');
    var title = rf.querySelector('[data-be-rf-routine-title]');
    var tpl = goal && document.querySelector('template[data-be-rf-routine="' + goal + '"]');
    list.innerHTML = '';
    if (tpl) list.appendChild(tpl.content.cloneNode(true));
    title.textContent = goal && S.routine ? S.routine[goal] || '' : '';
    title.hidden = !list.children.length;
    var first = list.querySelector('a');
    var shop = rf.querySelector('[data-be-rf-shop]');
    if (first && shop) shop.href = '/discount/WELCOME10?redirect=' + encodeURIComponent(first.getAttribute('href'));
    rfStep('done');
  }
  function showTeaser() {
    if (!teaser || D.rfTeaser !== '1' || signed() || within(K.teaserOff, parseInt(D.rfDays, 10) || 7)) return;
    if (D.template === 'product' && mq('(max-width: 749px)')) return; /* keeps the sticky add-to-bag clear */
    loadCss();
    teaser.hidden = false;
  }

  if (rf) {
    rfStep(1);
    rf.addEventListener('click', function (e) {
      if (e.target.closest('[data-be-rf-next]')) {
        var goal = rfGoal();
        var err = rf.querySelector('[data-be-rf-goal-error]');
        if (!goal) { err.hidden = false; var r = rf.querySelector('[data-be-rf-goal]'); if (r) r.focus(); return; }
        err.hidden = true;
        rfSetTags(goal);
        rfStep(2);
        window.setTimeout(function () { var em = rf.querySelector('#BeRoutineEmail'); if (em) em.focus(); }, 30);
        track('be_popup_goal', { goal: goal });
      }
      if (e.target.closest('[data-be-rf-back]')) { rfStep(1); var c = rf.querySelector('[data-be-rf-goal]:checked') || rf.querySelector('[data-be-rf-goal]'); if (c) c.focus(); }
      var a = e.target.closest('[data-be-rf-shop], .be-pop__product-link');
      if (a) track('be_popup_routine_click', { href: a.getAttribute('href') });
    });
    rf.addEventListener('change', function (e) { if (e.target.matches('[data-be-rf-goal]')) rf.querySelector('[data-be-rf-goal-error]').hidden = true; });
    var form = rf.querySelector('#BeRoutineForm');
    form.addEventListener('submit', function (e) {
      var em = form.querySelector('#BeRoutineEmail');
      var bad = !em.value || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim());
      var errEl = form.querySelector('[data-be-rf-email-error]');
      if (bad) { e.preventDefault(); errEl.hidden = false; em.setAttribute('aria-invalid', 'true'); em.focus(); return; }
      errEl.hidden = true; em.removeAttribute('aria-invalid');
      var goal = rfGoal();
      rfSetTags(goal);
      lsSet(K.rfPending, JSON.stringify({ goal: goal, t: Date.now() }));
      track('be_popup_submit', { goal: goal, source: 'routine_finder' });
    });
    rf.addEventListener('close', function () {
      if (rfDone) { if (teaser) teaser.hidden = true; return; }
      lsSet(K.rfLast, String(Date.now()));
      showTeaser();
    });
    if (teaser) {
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-be-rf-teaser-x]')) { teaser.hidden = true; lsSet(K.teaserOff, String(Date.now())); track('be_popup_teaser_hide'); return; }
        if (e.target.closest('[data-be-rf-teaser-open]')) { teaser.hidden = true; rfStep(rfGoal() ? 2 : 1); openDialog(rf, rfGoal() ? '#BeRoutineEmail' : '#BeRoutineTitle1'); track('be_popup_teaser_open'); }
      });
    }
  }

  /* Returning from the form post (Shopify adds ?customer_posted=true and the form's #anchor). */
  var hash = window.location.hash;
  var posted = /[?&]customer_posted=true/.test(window.location.search);
  var pending = null;
  try { pending = JSON.parse(lsGet(K.rfPending) || 'null'); } catch (e) {}
  var recent = pending && Date.now() - pending.t < 30 * 60 * 1000;

  if (rf && hash === '#BeRoutineForm' && rf.querySelector('.be-pop__msg--err')) {
    if (pending && pending.goal) { var g = rf.querySelector('[data-be-rf-goal][value="' + pending.goal + '"]'); if (g) g.checked = true; rfSetTags(pending.goal); }
    rfStep(2); openDialog(rf, '#BeRoutineEmail'); ssSet(K.session, 'routine');
    return;
  }
  if (rf && recent && (posted || (hash === '#BeRoutineForm' && rf.querySelector('[data-be-rf-result="ok"]')))) {
    lsSet(K.signed, String(Date.now())); lsDel(K.rfPending); ssSet(K.session, 'routine');
    rfShowDone(pending.goal); openDialog(rf, '#BeRoutineTitleDone');
    track('be_popup_subscribed', { goal: pending.goal, source: 'routine_finder' });
    return;
  }

  /* ---------------------------------------------------------------- Exit rescue */
  var ex = document.querySelector('[data-be-exit]');
  function exShow(name) {
    ex.querySelectorAll('[data-be-exit-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-be-exit-panel') !== name; });
    var t = ex.querySelector('[data-be-exit-panel="' + name + '"] .be-pop__title');
    if (t) ex.setAttribute('aria-labelledby', t.id);
    ex.setAttribute('data-variant', name);
  }
  function exFillCart(count, total) {
    var tierRow = ex.querySelector('[data-be-exit-tier]');
    var shipRow = ex.querySelector('[data-be-exit-ship]');
    if (tierRow && D.bundles === '1' && S.tier1) {
      tierRow.querySelector('[data-be-exit-tier-text]').textContent = count === 1 ? S.tier1.replace('[pct]', D.t2)
        : count === 2 ? S.tier2.replace('[current]', D.t2).replace('[pct]', D.t3) : S.tier3.replace('[pct]', D.t3);
      tierRow.hidden = false;
    }
    if (shipRow && D.ship !== 'none') {
      var th = parseInt(D.threshold, 10) || 0;
      shipRow.querySelector('[data-be-exit-ship-text]').textContent = D.ship === 'always' ? S.shipAlways
        : total >= th ? S.shipDone : S.shipAway.replace('[amount]', money(th - total));
      shipRow.hidden = false;
    }
  }
  if (ex) {
    ex.addEventListener('click', function (e) {
      var bag = e.target.closest('[data-be-exit-bag]');
      if (!bag) return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { e.preventDefault(); closeDialog(ex); drawer.open(); }
      track('be_exit_rescue_bag');
    });
    var exForm = ex.querySelector('#BeExitForm');
    if (exForm) exForm.addEventListener('submit', function () { track('be_popup_submit', { source: 'exit_rescue' }); });
    if (hash === '#BeExitForm' && ex.querySelector('[data-be-exit-result]')) {
      exShow('signup'); openDialog(ex); ssSet(K.session, 'exit');
      if (ex.querySelector('[data-be-exit-result="ok"]')) { lsSet(K.signed, String(Date.now())); track('be_popup_subscribed', { source: 'exit_rescue' }); }
      return;
    }
  }

  /* QA helper (also works in the theme editor): bePopups.open('routine' | 'exit-cart' | 'exit-signup' | 'done') */
  window.bePopups = {
    open: function (which) {
      if (which === 'done' && rf) { rfShowDone(rfGoal() || 'glow'); openDialog(rf); return; }
      if (which === 'routine' && rf) { rfStep(1); openDialog(rf, '#BeRoutineTitle1'); return; }
      if (ex && which === 'exit-cart') { exFillCart(2, 0); exShow('cart'); openDialog(ex); return; }
      if (ex) { exShow('signup'); openDialog(ex); }
    },
    reset: function () { [K.signed, K.rfLast, K.rfPending, K.teaserOff, K.exitLast].forEach(lsDel); try { sessionStorage.removeItem(K.session); } catch (e) {} }
  };

  if (editor) {
    if (D.editorPreview && D.editorPreview !== 'none') window.setTimeout(function () { window.bePopups.open(D.editorPreview); }, 400);
    return;
  }

  /* Another pop-up (e.g. a Shopify Forms embed) appearing counts as this session's overlay. */
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        for (var j = 0; j < list[i].addedNodes.length; j++) {
          var n = list[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          var tag = n.tagName.toLowerCase();
          var id = (n.id || '') + ' ' + (typeof n.className === 'string' ? n.className : '');
          if (tag.indexOf('shopify-forms') === 0 || /shopify-forms|forms-modal/i.test(id) || (n.querySelector && n.querySelector('[class*="shopify-forms"], iframe[src*="forms.shopifyapps"]'))) {
            if (!ssGet(K.session)) ssSet(K.session, 'forms');
          }
        }
      }
    }).observe(document.body, { childList: true });
  }

  /* Routine finder: timed / scroll trigger. */
  var rfDays = parseInt(D.rfDays, 10) || 7;
  if (rf && D.rf === '1' && !signed()) {
    if (within(K.rfLast, rfDays)) {
      showTeaser();
    } else if (!ssGet(K.session)) {
      var delay = (desktop ? parseInt(D.rfDesktopDelay, 10) || 12 : parseInt(D.rfMobileDelay, 10) || 20) * 1000;
      var scrollPct = (parseInt(D.rfScroll, 10) || 40) / 100;
      var minTime = desktop ? 4000 : 6000;
      var start = Date.now();
      var fired = false;
      var waits = 0;
      var tryOpen = function () {
        if (fired) return;
        if (ssGet(K.session) || signed()) { fired = true; cleanup(); return; }
        if (otherOverlayOpen(waits >= 4)) { waits++; window.setTimeout(tryOpen, 3000); return; }
        fired = true; cleanup();
        ssSet(K.session, 'routine');
        rfStep(1); openDialog(rf, '#BeRoutineTitle1');
        track('be_popup_shown', { source: 'routine_finder' });
      };
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h >= scrollPct && Date.now() - start >= minTime) tryOpen();
      };
      var timer = window.setTimeout(tryOpen, delay);
      var cleanup = function () { window.clearTimeout(timer); window.removeEventListener('scroll', onScroll); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.setTimeout(loadCss, Math.max(0, delay - 3000));
    }
  }

  /* Exit rescue: desktop, mouse leaves through the top of the window. */
  var exDays = parseInt(D.exitDays, 10) || 7;
  if (ex && D.exit === '1' && desktop && !within(K.exitLast, exDays) && !ssGet(K.session)) {
    var armed = false;
    var armTimer = window.setTimeout(function () { armed = true; loadCss(); }, (parseInt(D.exitDelay, 10) || 0) * 1000);
    var onLeave = function (e) {
      if (!armed || e.relatedTarget || e.clientY > 8) return;
      if (ssGet(K.session) || otherOverlayOpen()) return;
      armed = false; window.clearTimeout(armTimer); document.removeEventListener('mouseout', onLeave);
      fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var count = cart.item_count || 0;
          var variant = count > 0 ? 'cart' : !signed() ? 'signup' : '';
          if (!variant || ssGet(K.session)) return;
          if (variant === 'cart') exFillCart(count, cart.total_price || 0);
          ssSet(K.session, 'exit'); lsSet(K.exitLast, String(Date.now()));
          exShow(variant); openDialog(ex, variant === 'signup' ? '#BeExitEmail' : '#BeExitTitle');
          track('be_exit_rescue_shown', { variant: variant });
        })
        .catch(function () {});
    };
    document.addEventListener('mouseout', onLeave);
  }
})();
